<script>
	import { sidebar } from '../store.js';
	import SideBarToggle from './SideBarToggle.svelte';

	export let segment;

</script>

<style>
    a.button {
        font-size: 23px;
        text-transform: none;
        width: auto;
        font-family: 'Cuprum';
        color: #fff;
        margin-left: auto;
        margin-right: auto;
    }
    .block {
        padding-left: 10%;
        padding-right: 10%;
    }



	.toolbar div.menu {
		@apply hidden;
	}


	@screen lg {
		.toolbar div.menu {
			@apply  pl-10 pr-10;
		}
	}

	@screen md {
		.toolbar div.menu {
			@apply flex items-center justify-around w-full;
		}
	}

   

</style>

<!--<div class="toolbar flex justify-start items-center bg-primary w-full h-12">-->
<div class="toolbar z-10 sm_menu:fixed md:flex justify-start items-center bg-primary w-full h-12">
	<!--<div class="toggle flex-initial md:hidden ml-5 mr-3">-->
	<div class="toggle flex-initial md:hidden ml-5 mr-3">
		<!--<SideBarToggle />//-->
	</div>
	<div class="text-white text-center flex-initial w-full md:hidden mt-3">Адвокат Смирнова Е.В.</div>
	<div class="menu">
		{#each $sidebar.items as {path, title, comp}}
			<a rel='prefetch' href="/{path}" class="flex-initial text-white">{title}</a>
		{/each}
	</div>
</div>


